module.exports = __webpack_public_path__ + "static/media/HOME-image10.2141abea.png";